<template>
  <div id="buyer">
    <div class="tabbar">
      <div id="tabbar">
        <div
          class="tabbarItem"
          :class="item === selectItem ? 'isAcitve' : ''"
          v-for="(item, index) in tabbarItem"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="filter_search">
        <input
          type="text"
          class="filter_search_input"
          v-model="match"
          placeholder="请输入账户关键词"
        />
        <span class="filter_search_btn" @click="handleSearch">确认</span>
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select
            v-model="value"
            :popper-append-to-body="false"
            placeholder="选择时间"
            @change="handleSearch"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select
            v-model="selectGameValue"
            clearable
            :popper-append-to-body="false"
            placeholder="选择游戏"
            @change="handleSearch"
          >
            <el-option
              v-for="(item, index) in selectGame"
              :key="index"
              :label="item.label"
              :value="{ value: item.value, label: item.label }"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-radio-group
      class="status-filter"
      v-model="product_status"
      fill="#1A1D24"
      text-color="#1A1D24"
      @input="handleSearch"
    >
      <el-radio-button label="0">进行中</el-radio-button>
      <el-radio-button label="1">议价成功</el-radio-button>
      <el-radio-button label="2">议价失败</el-radio-button>
    </el-radio-group>
    <div class="product" v-if="totalCount !== 0">
      <div class="product-list">
        <div
          class="product-list-item"
          v-for="item in tableData"
          :key="item.earnest_order_no"
          @click="clickListItem(item)"
        >
          <img :src="item.image" class="left-image" alt="" />
          <div class="order">
            <div class="order-num">
              <div class="order-no">
                <img src="@/assets/image/bargin/bargin-logo.png" alt="" />
                <span>订单编号：{{ item.earnest_order_no }}</span>
              </div>
              <div class="bid-info" v-if="item.status !== 2">
                <div
                  class="my-price"
                  v-if="[1, 2, 4].includes(item.counter_status)"
                >
                  我的出价：{{ item.buyer_price }}元
                </div>
                <div class="word-active" v-if="item.counter_status === 4">
                  卖家还价：{{ item.seller_price }}元
                </div>
                <div
                  class="word-active"
                  v-if="
                    item.counter_status === 6 && item.new_reserve_price !== 0
                  "
                >
                  卖家底价：{{ item.new_reserve_price }}元
                </div>
                <div
                  class="word-active"
                  v-if="item.tail_order_add_time && item.status !== 2"
                >
                  实付金额：<span class="suffix">¥</span
                  ><span class="price">{{ item.order_amount }}</span>
                </div>
                <el-tag
                  size="mini"
                  v-if="item.counter_status === 3 && item.status === 0 && item.step < 3"
                  >已同意</el-tag
                >
                <el-tag
                  type="danger"
                  size="mini"
                  v-if="item.counter_status === 2"
                  >已拒绝</el-tag
                >
              </div>
              <div class="bid-info failed-info" v-else>
                <span class="status-pill">
                  <img
                    v-if="showFailedStatusIcon(item)"
                    src="@/assets/image/bargin/refund.png"
                    alt=""
                  />
                  {{ getFailedStatusText(item) }}
                </span>
              </div>
            </div>
            <div class="order-title">{{item.game_name + item.product_name }}</div>
            <div class="rowData-footer">
              <my-progress
                :rowData="item"
                @payOverTime="cancelOrder"
              ></my-progress>
              <btn-group
                :rowData="item"
                :button_list="item.button_list"
                @reFresh="reFreshList"
                @nextUrgeTimeChange="nextUrgeTimeChange(item)"
              >
              </btn-group>
            </div>
          </div>
        </div>
      </div>
      <div class="pages">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-size="PageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount"
        >
        </common-pagination>
      </div>
    </div>
    <div class="no_data" v-else>
      <empty-state
        title="暂无议价订单"
        description="可以调整筛选条件后再次查看"
        icon="el-icon-price-tag"
        :icon-size="52">
      </empty-state>
    </div>
    <downturn-deatilDia :show.sync="showDetail" :rowDetail="rowDetail" isBuyer>
      <template slot="btn">
        <btn-group
          @reFresh="getRowData"
          :rowData="rowDetail"
          :button_list="button_list"
          @nextUrgeTimeChange="nextUrgeTimeChange(rowDetail)"
        >
        </btn-group>
      </template>
    </downturn-deatilDia>
    <dialog-group
      :showDetail="showDetail"
      @reFresh="reFreshList"
    ></dialog-group>
    <my-dialog
      :show="changeShow"
      width="390"
      title="温馨提醒"
      text="<div>该商品内容已变动，请重新发起求降价！</div><div>若您已支付诚意买，将为您进行自动退款！</div>"
      btnText="确认"
      :btnFuc="redirectPage"
      :closeFun="() => (changeShow = false)"
    ></my-dialog>
  </div>
</template>
<script>
import {
  apiGameList,
  earnestList,
  earnestDetail,
  earnestGiveUp,
} from "@/request/API";
import myDialog from "@/components/myDialog.vue";
import myProgress from "@/components/myProgress";
import btnGroup from "./components/btnGroup";
import dialogGroup from "./components/dialogGroup.vue";
import downturnDeatilDia from "../components/downturnDeatilDia.vue";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
import Bus from "@/util/eventBus";

export default {
  name: "",
  props: {},
  components: {
    myProgress,
    btnGroup,
    downturnDeatilDia,
    dialogGroup,
    myDialog,
    CommonPagination,
    EmptyState,
  },
  data() {
    return {
      showDetail: false,
      product_status: "0",
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 10,
      // 默认每页显示的条数（可修改）
      PageSize: 5,
      // tabbar 选中项
      selectItem: "游戏账号",
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem: ["游戏账号"],
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        { value: "0", label: "全部" },
        { value: "1", label: "本周内" },
        { value: "2", label: "当月" },
        { value: "3", label: "三个月内" },
        { value: "4", label: "半年内" },
        { value: "5", label: "半年以上" },
        { value: "6", label: "一年内" },
      ],
      value: "",
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: "",
      match: "",
      //当前页码
      page: 1,
      //批量删除
      refuseData: {},
      counterofferInput: "",
      // 当前行详情
      rowDetail: {
        button_list: [],
      },
      // 列表详情按钮控制
      button_list: [],
      //  商品变动弹窗
      changeShow: false,
      redirectData: {},
    };
  },
  methods: {
    /**
     * @description: 催促倒计时
     * @param {*} item
     * @return {*}
     */
     nextUrgeTimeChange(item) {
      this.getBuyBargainList()
    },
    handleSearch() {
      this.page = 1
      this.getBuyBargainList()
    },
    getFailedStatusText(item) {
      if (item.refund_status == 0) return "诚意买订单已取消";
      if (item.refund_type === 1 && item.refund_status === 1) return "诚意买退款中...";
      if (item.refund_type === 2 && item.refund_status === 1) return "全款金额退款中...";
      if (item.refund_status == 3) return "退款成功";
      return item.schedule || "议价失败";
    },
    showFailedStatusIcon(item) {
      return item.refund_status === 1 && [1, 2].includes(item.refund_type);
    },
    // 查看底价
    getRowData(row) {
      this.getBuyBargainList((val) => {
        let obj = val.filter((item) => item.id === row.id)[0];
        this.rowDetail = obj;
        this.button_list = obj.button_list;
      });
    },
    //  关闭弹窗
    closeDialog() {
      this.showDetail = false;
    },
    // 刷新列表
    reFreshList() {
      this.closeDialog();
      this.getBuyBargainList();
    },
    // 超时取消订单
    cancelOrder(order_id) {
      // time_out用户主动点击为0   超时调用为1
      earnestGiveUp({ order_id, time_out: 1 })
        .then((res) => {
          this.getBuyBargainList();
          res.data.give_up_msg
            ? this.$message({
                message: res.data.give_up_msg,
                customClass: "counteroffer-msg",
              })
            : "";
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBuyBargainList();
    },
    clickListItem(item) {
      earnestDetail({
        order_id: item.id,
      }).then((res) => {
        this.rowDetail = res.data;
        this.button_list = res.data.button_list;
        this.showDetail = true;
      });
    },
    /**
     * 游戏账号 降价请求列表
     * @param type    时间下拉框
     * @param game_id 游戏下拉框
     * @param match   关键字
     * @param page    当前页码
     */
    getBuyBargainList(fn) {
      earnestList({
        type: this.value,
        match: this.match,
        page: this.page,
        pageSize: this.PageSize,
        status: this.product_status,
        game_id: this.selectGameValue.value,
      })
        .then((res) => {
          this.tableData = res.data.list;
          this.totalCount = res.data.total;
          if (fn && typeof fn === "function") fn(this.tableData);
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    //初始化数据
    onLoad() {
      //游戏列表  下拉框
      apiGameList({}).then((res) => {
        res.data.forEach((item, index) => {
          let options = new Object();
          options.value = item.game_id;
          options.label = item.game_name;
          this.selectGame.push(options);
        });
      });
      // 已成交 账号列表
      this.getBuyBargainList();
    },
    // 跳转页面
    redirectPage() {
       // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
      switch (this.redirectData.error_code) {
        case 10012:
          this.$router.push({
            path: "/gamedetails",
            query: {
              game_id: this.redirectData.game_id,
              id: this.redirectData.product_id,
            },
          });
          break;
        case 10013:
          this.$router.push({
            name: "SelectGame",
            query: {
              game_id: this.redirectData.game_id,
              game_alias:
                this.redirectData.game_id == "26" ? "yuanshen5" : "games",
            },
          });
          break;
      }
    },
  },
  created() {
    // 刷新列表
    Bus.$on("reFresh", () => {
      this.reFreshList();
    });
    //  关闭弹窗
    Bus.$on("closeDialog", () => {
      this.closeDialog();
    });
    //  商品二次编辑 下架  改价
    Bus.$on("productChange", (val) => {
      this.changeShow = true;
      this.product_status = "2";
      this.reFreshList();
      this.redirectData = val;
    });
  },
  mounted() {
    if(this.$route.query?.status == 'fail'){
      this.product_status = 2
    }
    //初始化数据
    this.onLoad();
    this.$WS.on('earnestRefresh', (e) => {
      if(e.data.user_type == 1){
        this.getBuyBargainList()
      }
    })
  },
  watch: {},
  beforeDestroy() {
    Bus.$off(["reFresh", "closeDialog", "productChange"]);
  },
};
</script>

<style lang='less' scoped>
/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

#buyer {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 620px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    #tabbar {
      display: flex;
      align-items: center;
      gap: 8px;

      .tabbarItem {
        position: relative;
        min-width: 76px;
        height: 34px;
        margin-right: 0;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
        cursor: pointer;
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;
      }

      .tabbarItem:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      .isAcitve,
      .isAcitve:hover {
        padding-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        background: var(--bg-dark, #1A1D24);
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      }

      .isAcitve::after,
      .isAcitve:hover::after {
        content: '';
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 5px;
        height: 3px;
        border-radius: 2px;
        background: var(--primary, #FF5A1F);
      }

      .tabbarItem:last-of-type {
        margin: 0;
      }
    }

    .filter_search {
      width: 318px;
      height: 40px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      position: static;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input {
        width: 100%;
        min-width: 0;
        height: 38px;
        background: transparent;
        border: none;
        outline: none;
        padding: 0 16px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn {
        position: static;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        cursor: pointer;
        box-shadow: 0 6px 14px rgba(255, 90, 31, 0.18);
        transition: box-shadow .2s ease, background .2s ease;
      }

      .filter_search_btn:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);
      }
    }
  }

  .filter {
    min-height: 40px;
    height: auto;
    margin: 18px 0 14px;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground {
      display: flex;
      align-items: center;
      gap: 12px;

      /deep/ .el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/ .el-input.is-focus .el-input__inner,
      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/ .popper__arrow {
        left: 155px !important;
      }

      /deep/ .el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/ .el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ .el-select-dropdown__item.hover,
      /deep/ .el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }

      .select_data,
      .select_game,
      .select_status,
      .select_Pstatus {
        margin-right: 0;
      }
    }
  }

  .status-filter {
    height: 42px;
    margin-bottom: 18px;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    gap: 6px;

    /deep/.el-radio-button {
      .el-radio-button__inner {
        position: relative;
        min-width: 92px;
        height: 32px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        border-radius: 4px;
        box-shadow: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;
      }

      .el-radio-button__inner:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      &.is-active {
        .el-radio-button__inner {
          color: #FFFFFF !important;
          background: var(--bg-dark, #1A1D24) !important;
          border-color: transparent;
          box-shadow: inset 0 -3px 0 var(--primary, #FF5A1F), 0 6px 14px rgba(26, 29, 36, 0.18);
        }
      }
    }

    /deep/.el-radio-button:first-child .el-radio-button__inner,
    /deep/.el-radio-button:last-child .el-radio-button__inner {
      border-radius: 4px;
    }
  }

  .product {
    font-family: PingFang SC;
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    &-list {
      min-height: 420px;
      padding: 0;

      &-item {
        min-height: 164px;
        border-top: 1px solid var(--border-soft, #E8E4DE);
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
        cursor: pointer;
        transition: background .2s ease, box-shadow .2s ease;

        &:first-child {
          border-top: none;
        }

        &:hover {
          background: var(--bg-tag, #F0EDE8);
          box-shadow: inset 3px 0 0 var(--primary, #FF5A1F);
        }

        .left-image {
          width: 160px;
          height: 112px;
          flex: 0 0 160px;
          object-fit: cover;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
        }

        .order {
          width: calc(100% - 180px);
          min-width: 0;

          &-num {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;

            .order-no {
              display: flex;
              align-items: center;
              min-width: 0;
              font-weight: 500;
              color: var(--text-secondary, #5A5F6B);
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;

              img {
                width: 20px;
                height: 20px;
                margin-right: 5px;
              }

              span {
                height: 24px;
                padding: 0 10px;
                display: inline-flex;
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: var(--bg-tag, #F0EDE8);
                border: 1px solid var(--border-soft, #E8E4DE);
                border-radius: 4px;
                line-height: 22px;
              }
            }

            .bid-info {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              flex-wrap: wrap;
              flex-shrink: 0;
              gap: 8px;
              min-height: 28px;

              div {
                color: var(--text-secondary, #5A5F6B);
                font-weight: 400;
                margin-right: 0;
              }

              .word-active {
                color: var(--primary, #FF5A1F);
                font-size: 14px;
                line-height: 20px;
                padding: 3px 10px;
                background: var(--primary-soft, #FCEDE5);
                border-radius: 4px;
              }

              /deep/ .el-tag {
                height: 22px;
                line-height: 20px;
                padding: 0 8px;
                border-radius: 4px;
                font-size: 12px;
              }

              /deep/ .el-tag--mini {
                color: var(--new, #00C16E);
                background: rgba(0, 193, 110, 0.10);
                border-color: transparent;
              }

              /deep/ .el-tag--danger {
                color: var(--hot, #FF2D55);
                background: rgba(255, 45, 85, 0.10);
                border-color: transparent;
              }

              .suffix {
                font-size: 13px;
                font-weight: 500;
              }
              .price {
                font-size: 18px;
                font-weight: 500;
              }

              .status-pill {
                min-height: 24px;
                padding: 3px 10px;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                flex: 0 0 auto;
                color: var(--hot, #FF2D55);
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;
                background: rgba(255, 45, 85, 0.10);
                border-radius: 4px;

                img {
                  width: 17px;
                  height: 17px;
                  flex: 0 0 auto;
                }
              }
            }

            .failed-info {
              flex-wrap: nowrap;
            }
          }

          &-title {
            margin: 14px 0 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 24px;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #111827);
            line-height: 24px;
          }

          .rowData-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            min-width: 0;
            font-family: PingFang SC-Regular, PingFang SC;

            /deep/.progress {
              width: 390px;
              flex: 1 1 390px;
              min-width: 320px;
            }

            /deep/.progress-label-item {
              white-space: nowrap;
            }

            /deep/.btn-group {
              min-width: 0;
              flex: 0 0 auto;
            }
          }
        }
      }
    }
    //分页
    .pages {
      width: 100%;
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
      border-top: 1px solid var(--border-soft, #E8E4DE);
    }
  }

  //暂无数据
  .no_data {
    min-height: 300px;
    padding: 64px 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
  }
}
</style>
<style lang="less">
.counteroffer-msg {
  border-radius: 4px;
  background: #fcf0f0;
  padding: 10px 43px;
  z-index: 9999999;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    color: #e47470;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
